import { MSocketHandle } from '../components/socket/MSocketHandle'

export const SocketIO = new MSocketHandle()
